"use strict";

/**
* Реквизит типа «Строка» и «Многострочный текст».
* 
* @class WebAccess.components.wrappers.form.requisites._details.Text
* @extends WebAccess.components.wrappers.form.requisites.Text
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @since 5.2.0.1300
*/
(function (global) {

  var Text = global.Text.extend([global._details.editModeMixin], {
    className: "DetailText"
   });

  global._details.Text = Text;
})(window.WA.CMP.wrappers.form.requisites);